<template>
  <ul :class="classes">
    <li class="menu-local__item" v-for="item in itemsList" :key="item._uuid">
      <slot name="item-structure" v-bind:item="item"></slot>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'AppMenuLocal',
  status: 'prototype',
  release: '1.0.0',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    dark: {
      type: Boolean,
      default: false
    },
    column: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return {
        'menu-local': 'menu-local',
        'menu-local--dark': !!this.dark,
        'menu-local--column': !!this.column
      }
    },
    itemsList () {
      return this.items.map((item, index) => {
        item._uuid = index
        return item
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
$padding-base: 15px;
.menu-local {
  @include reset();
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
  list-style: none;
  font-family: $font-text;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  &--dark {
    .menu-local__item > a {
      color: $color-white;
      &.menu__items_item--active,
      &:hover,
      &:focus {
        color: $color-yellow-lighter;
        border-bottom: 2px solid $color-yellow-lighter;
      }
    }
  }
  &--column {
    .menu-local__item {
      @media #{$media-query-l} {
        display: block;
        width: 100%;
        padding: 5px 0;
      }
    }
  }
  &__item {
    display: block;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    padding: 0;
    @media #{$media-query-l} {
      width: auto;
      display: flex;
      padding: 0 15px;
    }
    &:first-child {
      padding-left: 0;
    }
    & > a {
      @include reset();
      display: inline-block;
      height: 100%;
      padding: 10px 0;
      font-family: inherit;
      font-size: $size-s;
      font-weight: 600;
      color: $color-gray;
      text-decoration: none;
      outline: none;
      border-bottom: 2px solid transparent;
      &.menu__items_item--active,
      &:hover,
      &:focus {
        color: $color-purple-dark;
        border-bottom: 2px solid $color-purple-dark;
      }
    }
  }
}
</style>
